import { put, call, all, takeLatest } from "redux-saga/effects";
import {
  fetchTlogDataRequest,
  fetchTlogDataSuccess,
  fetchTlogDataFailure,
} from "./action";
import { FETCH_TLOG_DATA_SAGA } from "./types";
import { ADMIN_URL } from "../../config.js";
import fetch from "../../services/fetch.js";

function* fetchTlogData(action) {
  try {
    yield put(fetchTlogDataRequest());
    const {
      project_id,
      project_name,
      welduid_s_event_torch,
      view_type,
      torch_type,
      zone_name,
      tilt_start,
      tilt_end,
    } = action.payload;

    const url = new URL(`${ADMIN_URL}/v1/log`);
    if (project_id) url.searchParams.append("project_id", project_id);
    if (project_name) url.searchParams.append("project_name", project_name);
    if (welduid_s_event_torch)
      url.searchParams.append("welduid_s_event_torch", welduid_s_event_torch);
    if (view_type) url.searchParams.append("view_type", view_type);
    if (torch_type) url.searchParams.append("torch_type", torch_type);
    if (zone_name) url.searchParams.append("zone_name", zone_name);
    if (tilt_start == 0 || tilt_start)
      url.searchParams.append("tilt_start", tilt_start);
    if (tilt_end) url.searchParams.append("tilt_end", tilt_end);

    const response = yield fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 403) {
      throw new Error("Unauthorized access. Please check your permissions.");
    }

    const tlogData = yield response.json();
    if (tlogData.statusCode === 200) {
      yield put(fetchTlogDataSuccess(tlogData?.data));
      return;
    }

    throw new Error(tlogData.data?.message || "Failed to fetch TLOG data");
  } catch (error) {
    yield put(fetchTlogDataFailure(error.message));
  }
}

function* data360LiveTlogSagaWatcher() {
  yield takeLatest(FETCH_TLOG_DATA_SAGA, fetchTlogData);
}

export default function* data360LiveTlogSaga() {
  yield all([call(data360LiveTlogSagaWatcher)]);
}
